exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-form-container {\n  width: 100%;\n  margin: 20px 0; }\n  .user-form-container .asterisk {\n    display: inline-block;\n    width: 100%; }\n  .user-form-container .checkbox-container {\n    border-top: 1px solid rgba(0, 0, 0, 0.2);\n    margin-top: 20px;\n    padding-top: 20px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /dist/src/app/user/user-form/user-form.component.scss
// module id = ../../../../../src/app/user/user-form/user-form.component.scss
// module chunks = main